import React, { useEffect, useState } from 'react';
import { getFirestore, collection, doc, DocumentReference } from 'firebase/firestore';
import { useFirebase } from '../firebase/firebase-provider';
import { useAuth } from './auth-provider';

interface DataStoreContextType {
    userDb: DocumentReference | null | undefined;
    getUserStore: (uid: string) => DocumentReference | null;
}

const DataStoreContext = React.createContext<DataStoreContextType | undefined>(undefined);

export const useDataStore = () => {
    const context = React.useContext(DataStoreContext);
    if (context === undefined) {
        throw new Error('useDataStore must be used within a DataStoreProvider');
    }
    return context;
};

export function DataStoreProvider(props: any) {
    const app = useFirebase();
    const { currentUser, isVerified } = useAuth();
    const [userDb, setUserDb] = useState(currentUser ? getUserStore(currentUser.uid) : undefined);

    useEffect(() => {
        if (currentUser) {
            setUserDb(getUserStore(currentUser.uid));
        } else if (currentUser === null) {
            setUserDb(undefined);
        } else {
            setUserDb(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser]);

    function getUserStore(uid: string): DocumentReference | null {
        const db = getFirestore(app!);
        return isVerified?.() ? doc(db, 'users', uid) : null;
    }

    return (
        <DataStoreContext.Provider value={{ userDb, getUserStore }}>
            {props.children}
        </DataStoreContext.Provider>
    );
}
